<template>
  <div class="flex items-center space-x-2">
    <icon-base :icon="IconFormulaView" class="text-primary" />
    <lf-heading3>
      {{ $t("ATTRIBUTE_BUILDER.CUSTOM_ATTRIBUTES") }}
    </lf-heading3>
  </div>
</template>

<script setup lang="ts">
import IconFormulaView from "@/components/icons/IconFormulaView.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfHeading3 from "@/components/ui/text/LfHeading3.vue";
</script>
